module.exports = __webpack_public_path__ + "img/yantaiai-icon4.61eca74d.png";